// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CustomDateInput_wrapper__TYuuy {
  position: relative;
  width: 100%;
}

.CustomDateInput_dateInput__ZxkKl {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid rgba(203, 213, 225, 1);
  border-radius: 6px;
  font-size: 14px;
  color: #333;
  background-color: #fff;
  outline: none;
  transition: border-color 0.3s;
  cursor: pointer;
}

/* .dateInput:hover {
  border-color: #888;
}

.dateInput:focus {
  border-color: #007bff;
} */
`, "",{"version":3,"sources":["webpack://./src/styles/CustomDateInput.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,wCAAwC;EACxC,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,sBAAsB;EACtB,aAAa;EACb,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;;;;;;GAMG","sourcesContent":[".wrapper {\n  position: relative;\n  width: 100%;\n}\n\n.dateInput {\n  width: 100%;\n  padding: 8px 12px;\n  border: 1px solid rgba(203, 213, 225, 1);\n  border-radius: 6px;\n  font-size: 14px;\n  color: #333;\n  background-color: #fff;\n  outline: none;\n  transition: border-color 0.3s;\n  cursor: pointer;\n}\n\n/* .dateInput:hover {\n  border-color: #888;\n}\n\n.dateInput:focus {\n  border-color: #007bff;\n} */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `CustomDateInput_wrapper__TYuuy`,
	"dateInput": `CustomDateInput_dateInput__ZxkKl`
};
export default ___CSS_LOADER_EXPORT___;
